import React, { useEffect, useState } from 'react'
import { Col, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  fishTypeOptions,
  packedInOptionsDefault,
  sizeOptionsDefault,
  salmonPackedInOptions,
  salmonSizeOptions,
  sardinesPackedInOptions,
  sardinesSizeOptions,
  tunaPackedInOptions,
  tunaSizeOptions,
} from './constants'
import Select from 'react-select'
import PropTypes from 'prop-types'

const CannedFishPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    FishType: item.FishType,
    PackedIn: item.PackedIn,
    Size: item.Size,
  })
  const [packedInOptions, setPackedInOptions] = useState(packedInOptionsDefault)
  const [sizeOptions, setSizeOptions] = useState(sizeOptionsDefault)
  const setOptions = () => {
    if (item.FishType === 'Chunk, Light Tuna') {
      setPackedInOptions(tunaPackedInOptions)
      setSizeOptions(tunaSizeOptions)
    } else if (item.FishType === 'Pink Salmon') {
      setPackedInOptions(salmonPackedInOptions)
      setSizeOptions(salmonSizeOptions)
    } else if (item.FishType === 'Sardines') {
      setPackedInOptions(sardinesPackedInOptions)
      setSizeOptions(sardinesSizeOptions)
    }
  }

  const optionsReset = () => {
    methods.reset(
      { PackedIn: '', Size: '' },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }
  const methods = useFormContext()
  const { setSelectReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { FishType, PackedIn, Size } = item

      setPackaging({
        FishType,
        PackedIn,
        Size,
      })

      setOptions()
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <h6>Fish Type {asterisk}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={fishTypeOptions}
          defaultValue={{
            label: packaging.FishType,
            value: packaging.FishType,
          }}
          name="FishType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Fish Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            setOptions()
            optionsReset()
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="FishType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <h6>Size {item?.FishType !== '' ? asterisk : null}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={sizeOptions}
          defaultValue={{
            label: packaging.Size,
            value: packaging.Size,
          }}
          name="Size"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Size'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="Size"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
      <Col xs={6}>
        <h6>Packed in {item?.FishType !== '' ? asterisk : null}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={packedInOptions}
          defaultValue={{
            label: packaging.PackedIn,
            value: packaging.PackedIn,
          }}
          name="PackedIn"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Packed In'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PackedIn"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

CannedFishPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default CannedFishPackageReview
